import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Image, message, Space, Switch, Tag } from "antd";
import axios from "axios";
import { create } from "zustand";
import { MAIN_URL } from "../../../Constants";
import emptyimage from './../../../assets/images/emptyimage.jpg'
export const useProducts = create((set, get) => ({
    open: false,
    rend: false,
    setRend: (s) => set({ rend: s }),
    setOpen: (s) => set({ open: s }),
    products: [],
    variations: [],
    vrs: [],

    ed: {},
    setEd: (v) => { set({ ed: v }) },

    columns: [
        {
            title: "Rasm",
            dataIndex: 'img',
            key: 'img',
            render: (img) => <Image width={50} height={50} style={{ objectFit: 'cover', borderRadius: '5px', border: '1px solid #ccc' }} src={MAIN_URL + '/' + img} />,
            width: 80
        },
        {
            title: 'Nomi',
            dataIndex: 'nameuz',
            width: 250,
            key: 'nameuz',
            render: (text, record) => <span><b>UZ:</b>{record.nameuz} <br /><b>RU:</b>{record.nameru}</span>
        },
        {
            title: 'Mashina',
            dataIndex: 'brand',
            width: 250,
            key: 'brand',
            render: (text, record) => <>
                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}><b>Marka:</b>{record.brands.map(b => <Tag color='blue' key={b.id}>{b.nameuz}</Tag>)}</div>
                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}><b>Mashina:</b>{record.models.map(b => <Tag color='green' key={b.id}>{b.nameuz}</Tag>)}</div>
            </>
        },

        {
            title: "Galereya",
            dataIndex: 'gallery',
            key: 'gallery',
            render: (_, rec) => {
                let ims = rec?.gallery
                return <Image.PreviewGroup>
                    <Space>
                        {ims?.map((img) => <Image key={img} width={50} height={50} style={{ objectFit: 'cover', borderRadius: '5px', border: '1px solid #ccc', marginRight: '5px' }} src={img ? MAIN_URL + '/' + img : emptyimage} />)}
                    </Space>
                </Image.PreviewGroup>
            }
        },
        {
            title: "Variantlari soni",
            dataIndex: 'var_count',
            key: 'var_count',
            render: (text, record) => <span><Tag color="blue">{record.var_count} ta variant</Tag><br /> <Tag color="red">Jami: <b>{record.count}</b> dona qoldiq </Tag></span>
        },
        {
            title: "Yaratilgan",
            dataIndex: 'created_at',
            key: 'created_at',
            render: (date) => <span>{new Date(date).toLocaleString('ru-RU')}</span>
        },
        {
            title: "Yangilangan",
            dataIndex: 'updated_at',
            key: 'updated_at',
            render: (date) => <span>{new Date(date).toLocaleString('ru-RU')}</span>
        },
        {
            title: "Tovar holati",
            dataIndex: 'status',
            key: 'status',
            render: (status, record) => <><Tag color={status ? "green" : "red"}>{status ? "Faol" : "Nofaol"}</Tag>  <Switch checked={status} onChange={(e) => {
                get().updateProduct({ id: record.id, status: e })
            }} /></>
        },
    ],
    fetchProducts: async () => {
        try {
            const response = await axios.get('/prds');
            set({ vrs: response.data });
        } catch (error) {
            console.error('Error fetching products:', error);
        }
    },
    getProducts: () => {
        axios.get('/prds').then(res => {
            set({ products: res.data })
        })
    },
    createProduct: (v) => {
        axios.post('/products', v).then(res => {
            get().getProducts()
            message.success("Muvaffaqiyatli qo'shildingiz!")
            localStorage.removeItem('variation')
        })
    },
    deleteProduct: (_, p) => {
        axios.delete('/products/' + p.id).then(res => {
            if (res.status === 200) {
                get().getProducts()
                message.success("Muvaffaqiyatli o'chirdingiz!")
            }
        })
    },
    updateProduct: (v) => {
        axios.put('/products/' + v.id, v).then(res => {
            get().getProducts()
            message.success("Muvaffaqiyatli o'zgartirdingiz!")
        })
    },

    deletePR: (id)=>{
        axios.delete('/deleteproduct/' + id).then(data=>{
            get().getProducts()
            message.success("O'chirildi")
        })
    }
}))